const config = {
  title: "A2C",
  apiURL: "https://api.a2csum.com/",
  mediaURL: "https://4n7dissrid.execute-api.eu-west-3.amazonaws.com/",
  mediaName: "a2c",
  deploy: {
    title: "PROD",
    url: "https://api.netlify.com/build_hooks/60eee490399d0931bf0b674c",
    afterDeployUrl: "https://www.a2csum.com",
  },
  menu: [
    {
      type: "Home",
      title: "Pages",
      path: "/admin/edit/Home/1",
      items: [
        {
          type: "Home",
          title: "Home",
          path: "/admin/edit/Home/1",
        },
        {
          type: "PageProducts",
          title: "Products",
          path: "/admin/edit/PageProducts/1",
        },
        {
          type: "PageCalendar",
          title: "Calendar",
          path: "/admin/edit/PageCalendar/1",
        },
        {
          type: "PageNews",
          title: "News",
          path: "/admin/edit/PageNews/1",
        },
        {
          type: "PageAbout",
          title: "About",
          path: "/admin/edit/PageAbout/1",
        },
        {
          type: "AboutMenu",
          title: "About Menu",
          path: "/admin/list/AboutMenu",
        },
        {
          type: "PageContact",
          title: "Contact",
          path: "/admin/edit/PageContact/1",
        },
        {
          type: "PageLegalText",
          title: "Legal",
          path: "/admin/edit/PageLegalText/1",
        },
        {
          type: "Page404",
          title: "404",
          path: "/admin/edit/Page404/1",
        },
        {
          type: "Common",
          title: "Common",
          path: "/admin/edit/Common/1",
        },
      ],
    },
    {
      type: "Product",
      title: "Products",
      items: [
        {
          type: "Product",
          title: "Products",
        },
        {
          type: "ProductCategory",
          title: "Categories",
        },
      ],
    },
    {
      type: "Event",
      title: "Events",
      items: [
        {
          type: "Event",
          title: "Event",
        },
        {
          type: "EventsFilter",
          title: "EventsFilter",
        },
      ],
    },
    {
      type: "News",
      title: "News",
    },
    {
      type: "User",
      title: "Config",
      items: [
        {
          type: "User",
          title: "Users",
        },
        {
          type: "Language",
          title: "Languages",
        },
        {
          type: "Literal",
          title: "Literals",
        },
        {
          type: "LiteralText",
          title: "LiteralsText (textarea)",
        },
      ],
    },
  ],
};

export default config;
